import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { EMPTY, Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment.prod';
import { AppModulesType } from '../../../../_shared/enums/appModulesType.enum';
import { Case, Event, Task, TimeList } from '../../../../_shared/model';
import { GuiUserContractorSettings } from '../../../../_shared/model/userGuiSettings/guiUserContractorSettings.model';
import { MfToastService, StorageService } from '../../../../_shared/services';
import { ActiveModulesService } from '../../../../_shared/services/activeModules.service';
import { IndexService, NotificationService, ReservationService, TaskService, VisitService } from '../_services';
import { ConfigGUIService } from '../_services/configGUI.service';
import { HelperService } from './../../../../_shared/services/helper.service';
import { MenuService } from './../../../../_shared/services/menu.service';
import { CommonService } from './../_services/common.service';
import { TermsAndConditionsAlertHandler } from './model/terms-and-conditions-alert-handler';

@Component({
    selector: 'app-home-index',
    templateUrl: './index.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public resultList: Observable<any>;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public notificationsList: Observable<any>;
    public demoObjectList: TimeList[];
    public demoTasks: Task[] = [];
    private onDestroy$ = new Subject<void>();
    public version: string = environment.VERSION;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public year: any = new Date().getFullYear();
    public isKanbanModuleAcite = false;
    public isOnboardingActive = false;
    public expanded = false;
    private termsAndConditionsAlertHandler: TermsAndConditionsAlertHandler;
    constructor(
        private rest: IndexService,
        private storage: StorageService,
        private route: Router,
        private visitRest: VisitService,
        private taskRest: TaskService,
        private notifRest: NotificationService,
        private reservRest: ReservationService,
        private mfToast: MfToastService,
        private configGUIRest: ConfigGUIService, // private printRest: PrinterService
        private store: Store,
        private menu: MenuService,
        private am: ActiveModulesService,
        public helper: HelperService,
        private commonRest: CommonService,
    ) {
        moment.locale('sl');
        this.termsAndConditionsAlertHandler = new TermsAndConditionsAlertHandler();
    }
    ngOnInit() {
        moment.locale('sl');

        this.isKanbanModuleAcite = this.am.isAM(AppModulesType.KANBAN);
        this.isOnboardingActive = this.am.isAM(AppModulesType.ONBOARDING_WIZARD);

        this.handleTermsConditionsAndVersionNotifications();
        this.handleMainMenuAndLoadKanban();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    // public testPrint(): void {
    //     this.printRest.testPrint();
    // }

    public loadForTime(event): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let to: any;

        if (event === 'week') {
            to = moment().add(7, 'd').format('YYYY-MM-DD');
        } else {
            to = moment().endOf('day').format('YYYY-MM-DD');
        }
        this.resultList = this.rest
            .getReservationList(
                this.storage?.getSelectedContractor()?.id,
                this.storage?.getUserData()?.subcontractorId,
                moment().add(0, 'd').format('YYYY-MM-DD'),
                to,
            )
            .pipe(
                catchError(err => {
                    this.resultList = of([]);
                    return err;
                }),
                map(res => {
                    const cx = res.map(res => {
                        if (res.title) {
                            return new TimeList().deserialize({
                                id: res.visitId,
                                from: res.reservationFrom,
                                primText: res.title,
                                classColor: 'm-timeline-3__item--warning',
                                data: res,
                                secText: [
                                    {
                                        text: _.get(res, 'contractor.subcontractors[0].name', ''),
                                        icon: 'la la-stethoscope',
                                    },
                                ],
                            });
                        } else {
                            return new TimeList().deserialize({
                                id: res.visitId,
                                from: res.reservationFrom,
                                primText: _.get(res, 'service.name', ''),
                                classColor: 'm-timeline-3__item--info',
                                data: res,
                                secText: [
                                    {
                                        text: _.get(res, 'contractor.subcontractors[0].name', ''),
                                        icon: 'la la-stethoscope',
                                    },
                                    {
                                        text: _.get(res, 'customer.name', '') + ' ' + _.get(res, 'customer.surname', ''),
                                        icon: 'la la-user',
                                    },
                                ],
                            });
                        }
                    });
                    return cx;
                }),
            );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openReservation(event: any): void {
        if (!_.isNil(event.data.title)) {
            this.mfToast.info('Interna rezervacija.');

            this.route.navigate(['calendar']);
        } else if (!_.isNil(event.data.visitId)) {
            this.visitRest
                .isVisitConcluded(this.storage.getSelectedContractor().id, event.data.visitId)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(res => {
                    event.data.isConcluded = res == 'true';

                    const data = new Event().deserialize(event.data);
                    data.case = new Case().deserialize({
                        caseId: event.data.caseId,
                        bsid: event.data.bsid,
                    });
                    this.storage.setSelectedTerm(data);
                    this.route.navigate([`calendar/selected/${data.prereservationId}`]);
                });
        } else {
            const data = new Event().deserialize(event.data);
            data.case = new Case().deserialize({
                caseId: event.data.caseId,
                bsid: event.data.bsid,
            });
            this.storage.setSelectedTerm(data);
            this.route.navigate([`calendar/selected/${data.prereservationId}`]);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openReservationFromNotification(notif: any) {
        this.reservRest
            .getReservation(this.storage.getSelectedContractor().id, notif.data.prereservationId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(res => {
                if (!_.isNil(res) && !_.isNil(res.visitId)) {
                    this.visitRest.isVisitConcluded(this.storage.getSelectedContractor().id, res.visitId).subscribe(() => {
                        res.isConcluded = true;
                        const data = new Event().deserialize(res);
                        data.case = new Case().deserialize({
                            caseId: res.caseId,
                            bsid: res.bsid,
                        });
                        this.storage.setSelectedTerm(data);
                        // this.route.navigate(['terms/selected']);
                        this.route.navigate([`calendar/selected/${data.prereservationId}`]);
                    });
                } else {
                    const data = new Event().deserialize(res);
                    data.case = new Case().deserialize({
                        caseId: res.caseId,
                        bsid: res.bsid,
                    });

                    this.storage.setSelectedTerm(data);
                    // this.route.navigate(['terms/selected']);
                    this.route.navigate([`calendar/selected/${data.prereservationId}`]);
                }
            });
    }

    public concludeTask(event, task): void {
        this.taskRest.concludeTask(this.storage.getSelectedContractor().id, task.id).subscribe(
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            res => {
                this.mfToast.success('Opravilo uspešno zaključeno.');
            },
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            err => {
                this.mfToast.errorAndSend('Napaka pri zaključku opravila.');
            },
        );
    }

    private handleTermsConditionsAndVersionNotifications(): void {
        this.configGUIRest
            .getGlobalSettings()
            .pipe(
                switchMap(globalSettingsResponse => {
                    const tacData: { version: string } = _.get(this.storage.getGuiUserSettings(), 'app.termsAndConditions');
                    const newReleaseVersion: string = _.get(this.storage.getGuiUserSettings(), 'app.newReleaseVersion');

                    if (_.get(tacData, 'version', '') !== globalSettingsResponse.version) {
                        return this.termsAndConditionsAlertHandler.showTermsAndConditions(globalSettingsResponse).pipe(
                            tap(swalResult => {
                                if (swalResult.isConfirmed) {
                                    // Initialize user settings on first login
                                    const userSettings: GuiUserContractorSettings = new GuiUserContractorSettings();
                                    userSettings.app.termsAndConditions = globalSettingsResponse;
                                    userSettings.app.newReleaseVersion = globalSettingsResponse?.newRelease?.version;
                                    this.configGUIRest.updateUserContractorGuiSettings(this.storage.getSelectedContractor().id, userSettings);
                                }
                            }),
                        );
                    } else if (newReleaseVersion != globalSettingsResponse?.newRelease?.version) {
                        return this.termsAndConditionsAlertHandler.showNewReleaseInfo(globalSettingsResponse).pipe(
                            tap(() => {
                                return this.configGUIRest.updateUserGuiAppSettingsNewRelease(
                                    this.storage.getSelectedContractor().id,
                                    globalSettingsResponse?.newRelease?.version,
                                );
                            }),
                        );
                    }
                    return EMPTY;
                }),
                catchError(() => EMPTY),
            )
            .subscribe();
    }

    private handleMainMenuAndLoadKanban(): void {
        if (!this.storage.getSelectedContractor()) {
            return;
        }
        this.menu.resetMenu();

        if (!this.isKanbanModuleAcite) {
            this.loadForTime('');
        }
    }
}
